import { FC, useContext } from "react";
import type { FieldErrors } from "react-hook-form";

import { UseFormReturn, Form, SubmitButton } from "capitalrx-components-2.0/lib/forms";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { StatusFormBlock, PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";

import { ProviderContactInformationDataForm, ContactInformationGroupFields } from "./ContactInformationGroupFields";
import { Button } from "capitalrx-components-2.0/lib/general";

export interface ContactInformationFormProps {
  readonly onCancel: () => void;
  readonly onSubmit: (data: ProviderContactInformationDataForm) => Promise<void>;
  readonly onInvalid: (errors: FieldErrors<ProviderContactInformationDataForm>) => void;
  readonly type: StatusFormBlock;
  readonly form?: UseFormReturn<ProviderContactInformationDataForm>;
  readonly onEdit: () => void;
}

export const ContactInformationForm: FC<ContactInformationFormProps> = ({ onCancel, onSubmit, onInvalid, type, form, onEdit }) => {
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const ButtonGroup = isCompressed ? Stack : Shelf;

  const readOnly = type === "complete";
  const { primary_color } = useContext(ThemeSelectorContext);

  return (
    <Form form={form} onSubmit={onSubmit} onInvalid={onInvalid}>
      <Stack spacing="large">
        <ContactInformationGroupFields readOnly={readOnly} onEdit={onEdit}/>
        {type === "edit" && (
          <Stack alignment={isCompressed ? "span" : "left"}>
            <ButtonGroup spacing="small">
              <SubmitButton appearance={getThemeButton("primary", primary_color)} testId="edit_provider_contact_information_form_submit_button">Save</SubmitButton>
              <Button
                appearance={getThemeButton("secondary", primary_color)}
                onClick={onCancel}
                testId="edit_provider_contact_information_form_clear_fields_button"
              >
                Discard Changes
              </Button>
            </ButtonGroup>
          </Stack>
        )}
      </Stack>
    </Form>
  );
};
